export default __webpack_public_path__ + "static/media/does_not_cover_mobile.41711677.png";